import classNames from 'classnames';
import useMobileWidth from 'hooks/useMobileWidth';
import * as styles from './styles/collageStyles.module.scss';

const EMPLOYEE_COLLAGE_CAPTIONS: Record<number, string> = {
  0: 'Trail day in Colorado',
  1: 'Offsite at Heart Lake Trail',
  2: 'Shooting a commercial',
  3: 'Field testing'
};

const getCollageImage = (idx: number, containerClassName?: string, captionClassName?: string, photoWidth?: number): JSX.Element => {
  const picJpg = require(`../../../../assets/images/careers/employee-collage-${photoWidth ? `${photoWidth}w-` : ''}${idx}.jpg`);
  const picAvif = require(`../../../../assets/images/careers/employee-collage-${photoWidth ? `${photoWidth}w-` : ''}${idx}.avif`);
  const picWebp = require(`../../../../assets/images/careers/employee-collage-${photoWidth ? `${photoWidth}w-` : ''}${idx}.webp`);
  const caption = EMPLOYEE_COLLAGE_CAPTIONS[idx];
  return (
    <div className={classNames(styles.imageContainer, containerClassName)}>
      <picture>
        <source srcSet={picAvif} type="image/avif" />
        <source srcSet={picWebp} type="image/webp" />
        <img src={picJpg} alt={caption} className={styles.collageImage} loading="lazy" />
      </picture>
      <div className={classNames(styles.imageCaption, captionClassName)}>{caption}</div>
    </div>
  );
};

const EmployeeCollage = (): JSX.Element => {
  const isMobileView = useMobileWidth();

  return (
    <div className={styles.collage}>
      <div className={classNames(styles.collageCol, styles.endAlign)}>
        {getCollageImage(0, styles.image0, isMobileView ? styles.imageCaptionBottom : styles.imageCaptionTop, isMobileView ? 336 : null)}
        {getCollageImage(1, styles.image1, styles.imageCaptionBottom, isMobileView ? 335 : null)}
      </div>
      <div className={styles.collageCol}>
        {getCollageImage(2, styles.image2, styles.imageCaptionTop, isMobileView ? 335 : null)}
        {getCollageImage(3, styles.image3, styles.imageCaptionBottom, isMobileView ? 225 : null)}
      </div>
    </div>
  );
};

export { EmployeeCollage as default, EMPLOYEE_COLLAGE_CAPTIONS };
